const RANK = (value, { _data: data }) =>
  Array.from(new Set(data))
    .sort((a, b) => b - a)
    .indexOf(value) + 1;

export default RANK;
